import React, { useMemo } from 'react';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import MultiSelect from '../../../../../Components/Base/MultiSelect/MultiSelect';
import { useTermItemsQuery } from '../../../../../graphql/graphql';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import Loading from '../../../../../Components/Loading';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import FormControl from '../../../../../Components/Form/FormControl';
import apiClient from '../../../../../Services/ApiClient';
import useApiClient from '../../../../Base/Hooks/useApiClient';

interface Props {
	defaultValues: SelectValue[];
	userId: string;
	onSuccess: () => void;
}

const validationSchema = yup.object({
	insuranceCompanies: yup.mixed().notRequired(),
});

const TherapistInsuranceCompaniesEdit: React.FC<Props> = ({
	defaultValues,
	userId,
	onSuccess,
}) => {
	const { displayError } = useApiClient();
	const { data, isLoading } = useTermItemsQuery({
		termType: 'insurance_companies',
		take: 999,
	});

	const formMethods = useForm({
		defaultValues: defaultValues || {},
		resolver: yupResolver(validationSchema),
	});

	const options = useMemo(() => {
		const items: SelectValue[] = [];
		for (const termItem of data?.termItems?.data || []) {
			if (termItem) {
				items.push({
					value: termItem.id,
					label: termItem.name || termItem.id || '',
				});
			}
		}
		return items;
	}, [data]);

	const handleOnSubmit = async (values: any) => {
		const termItems: { id: string }[] = values.insuranceCompanies.map(
			(item: SelectValue) => ({ id: item.value }),
		);

		try {
			await apiClient.patch(`/doctors/${userId}`, {
				termItems,
				termType: 'insurance_companies',
			});
		} catch (e) {
			displayError(e);
		}
		onSuccess();
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FormWrapper formMethods={formMethods}>
			<FormControl
				label='component.therapistDetail.insuranceCompanies'
				name='insuranceCompanies'
				isRequired>
				<MultiSelect options={options} placeholder='base.select' />
			</FormControl>
			<SubmitButton onSubmit={handleOnSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default TherapistInsuranceCompaniesEdit;
